import { useEffect, useState } from "react";

import { API_GET_EMPLOYEE_FILE } from "../../../../../config/Endpoints.js";
import { getApi } from "../../../../utils/api.ts";
import { accessToken } from "../../../../utils/auth.ts";

function isBrowserImageUrl(value: string): boolean {
  return /^(https?:|data:|blob:)/i.test(value);
}

function getEmployeePhotoFilePath(photoPath: string): string {
  const fileMarker = "/file/";
  const markerIndex = photoPath.indexOf(fileMarker);
  return markerIndex >= 0
    ? photoPath.slice(markerIndex + fileMarker.length)
    : photoPath.replace(/^\/+/, "");
}

export function useEmployeePhotoSource(photoPath?: string): string | undefined {
  const normalizedPath = photoPath?.trim() ?? "";
  const directUrl = normalizedPath && isBrowserImageUrl(normalizedPath)
    ? normalizedPath
    : undefined;
  const [securedUrl, setSecuredUrl] = useState<string>();

  useEffect(() => {
    if (!normalizedPath || directUrl) {
      setSecuredUrl(undefined);
      return;
    }

    const controller = new AbortController();
    let objectUrl: string | undefined;
    const employeePhotoFilePath = getEmployeePhotoFilePath(normalizedPath);

    void getApi<Blob>(
      `${API_GET_EMPLOYEE_FILE}?filepath=${encodeURIComponent(employeePhotoFilePath)}`,
      accessToken(),
      "blob",
      controller.signal,
    )
      .then(({ data }) => {
        objectUrl = URL.createObjectURL(data);
        setSecuredUrl(objectUrl);
      })
      .catch(() => {
        if (!controller.signal.aborted) setSecuredUrl(undefined);
      });

    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [directUrl, normalizedPath]);

  return directUrl ?? securedUrl;
}
